import Backbone from "backbone";
import _ from "underscore";
import {availabilityUtils, sort, rent} from "utils";

const UnitModel = Backbone.Model.extend({
    availabilityLink: function() {
        return (
            this.get("realpage_apply_link") || this.get("availability_link")
        ).trim();
    },
    availabilityHTML: function(applyText, useNewTab, useContactFormButton=false) {
        let link = this.availabilityLink();

        if (useContactFormButton) {
            return availabilityUtils.makeContactForm(applyText, this);
        }

        if (!link) {
            return "";
        }

        if (availabilityUtils.isCoreLogicLink(link)) {
            return availabilityUtils.makeCoreLogicForm(link, applyText, this, useNewTab, true);
        }

        return availabilityUtils.makeDefaultAvailLink(link, applyText, useNewTab, true);
    },
    display_bath: function() {
        return this.get("bath").toPrecision(2).toString();
    },
    getAvailableDate: function() {
        return this.get("available_date");
    },
    getMinimumRent: function() {
        let min = Infinity;

        let values = this.get("rentValues");
        if (values.length && values[0] < min) {
            min = values[0];
        }

        return min;
    },
    getNumberSlug: function() {
        return this.get("number").replaceAll(" ", "-");
    },
    getFloorPlanName: function() {
        return this.get("floor_plan");
    },
    getVendorAmenities: function() {
        return this.get("vendor_amenities");
    },
    hasUnitNumber: function(number) {
        var ours = this.get("number").toLowerCase();

        return ours.indexOf(number.toLowerCase()) > -1;
    },
    promo: function() {
        let promo = this.get("promo_description");
        let expiration = this.get("promo_description_expiration");

        if (expiration && expiration < Date.now()) {
            return "";
        }

        return promo;
    }
});

export {UnitModel};
